import { VideoTemplateEditorFeatures } from 'components/VideoTemplateEditor';
import bem from 'utils/bem';

export const addPodcastStepBlock = bem('add-podcast-step');

export const EPISODE_TEMPLATE_EDITOR_FEATURES: VideoTemplateEditorFeatures = {
  progress: 'hidden',
  waveform: {
    fidelity: {
      disabled: true,
      reason: 'Full episodes use lo-fi wave generation',
    },
  },
};
